import { Maybe } from '@/types/schema';

export const RATING_MAX = 5;

export const getRatingMaxValue = (maxValue?: Maybe<number>) => maxValue || RATING_MAX;

export const getRatingOptions = (count: number) =>
  Array.from({ length: count }, (_, i) => (i + 1).toString());
